module.exports = __webpack_public_path__ + "img/transfer_26432fd.svg";